// extracted by mini-css-extract-plugin
export default {"modal-background":"piVSk","modalBackground":"piVSk","modal":"U3kZg"};